import React, {Component} from 'react';
import {Link} from "react-router-dom";
import '../FaqPages/DataCreationAndUpload.css'
import FocusPageId from "../../FocusPageId";
import '../Beginners.css'
class DataCreationAndUploadTopics extends Component {
    constructor(props){
        super(props);

        this.focusPage = this.focusPage.bind(this);

    }

    focusPage =(elementId)=>{
        FocusPageId.selectedId={elementId}
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {

        return (
            <div className="static-pages">
                <div className="background-div">
                    <h3><b><span>データ作成・アップロードについて</span></b></h3>

                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("a")}>
                        <Link to='/datacreationandUpload'>
                            <h4><b className="reduce-font-size cart-row-text-color"> いつガーバーファイルをアップロードすればいいですか？</b>
                            </h4>
                        </Link>

                    </div>


                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("b")}>
                        <Link to='/datacreationandUpload'>
                            <h4> <b className="reduce-font-size cart-row-text-color">前回のガーバーデータに、修正を加えて注文することが可能ですか？</b>
                            </h4>
                        </Link>

                    </div>


                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("c")}>
                        <Link to='/datacreationandUpload'>
                            <h4><b className="reduce-font-size cart-row-text-color">営業時間外、休業日にガーバーファイルをアップロードしても構いませんか？</b>
                            </h4>
                        </Link>

                    </div>


                     <div className="brElement"></div>
                    {/*<div onClick={()=>this.focusPage("d")}>
                        <Link to='/datacreationandUpload'>
                            <h4> <b>推奨されるGERBERDATAのファイル名</b>
                            </h4>
                        </Link>

                    </div>

                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("e")}>
                        <Link to='/datacreationandUpload'>
                            <h4><b>Altium PCBからガーバー出力方法</b>
                            </h4>
                        </Link>

                    </div>


                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("f")}>
                        <Link to='/datacreationandUpload'>
                            <h4><b> イーグルPCBからガーバー出力方法</b>
                            </h4>
                        </Link>

                    </div>


                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("g")}>
                        <Link to='/datacreationandUpload'>
                            <h4><b> Kicad PCBからガーバー出力方法</b>
                            </h4>
                        </Link>

                    </div>


                     <div className="brElement"></div>
                    <div onClick={()=>this.focusPage("h")}>
                        <Link to='/datacreationandUpload'>
                            <h4><b> Diptrace PCBからガーバー出力方法</b>
                            </h4>

                        </Link>

                    </div>*/}
                    {/*<div className='col-md-10'></div>*/}
                    <div className='faq-link-float-right   col-12-custom'>
                        <Link to="/frequent">
                            <span className='font-size-20 reduce-font-size'>
                            戻る
                            </span>
                        </Link>
                    </div>
                </div>
            </div>

        );
    }
}

export default DataCreationAndUploadTopics;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/FaqTopicsPages/DataCreationAndUploadTopics.js